import * as CommonConstants from '../../action/common/CommonConstants';
import {
  GET_FB_IMAGE_URL_FAILED,
  GET_FB_IMAGE_URL_REQUEST,
  GET_FB_IMAGE_URL_SUCCESS
} from '../../action/qc_fr/QC_FRConstants';

const initialState = {
  domainDataIsFetching: false,
  domainData: {},
  domainDataErrorMessage: '',

  getNoCommercialReasonsIsLoading: false,
  getNoCommercialReasonsData: {},
  getNoCommercialReasonsErrorMessage: '',

  imageDataIsFetching: false,
  imageData: {},
  imageDataErrorMessage: '',

  getImagesTableAgenciesIsLoading: false,
  getImagesTableAgenciesErrorMessage: '',
  getImagesTableAgenciesData: {},

  languagesDataIsFetching: false,
  languagesData: [],
  languagesDataErrorMessage: '',

  facebookImageIsFetching: false,
  facebookImageUrl: {},
  facebookImageUrlError: ''
};

export const commonStore = (state = initialState, action) => {
  switch (action.type) {
    case CommonConstants.GET_DOMAIN_DATA_REQUEST:
      return {
        ...state,
        domainDataIsFetching: true,
        domainDataErrorMessage: ''
      };
    case CommonConstants.GET_DOMAIN_DATA_SUCCESS:
      return {
        ...state,
        domainDataIsFetching: false,
        domainData: action.data
      };
    case CommonConstants.GET_DOMAIN_DATA_FAILED:
      return {
        ...state,
        domainDataIsFetching: false,
        domainDataErrorMessage: 'SERVER ERROR'
      };
    case CommonConstants.GET_DOMAIN_DATA_CLEAR:
      return {
        ...state,
        domainDataIsFetching: false,
        domainData: {},
        domainDataErrorMessage: ''
      };

    case CommonConstants.GET_NO_COMMERCIAL_REASONS_REQUEST:
      return {
        ...state,
        getNoCommercialReasonsIsLoading: true,
        getNoCommercialReasonsErrorMessage: ''
      };
    case CommonConstants.GET_NO_COMMERCIAL_REASONS_SUCCESS:
      return {
        ...state,
        getNoCommercialReasonsIsLoading: false,
        getNoCommercialReasonsData: action.data
      };
    case CommonConstants.GET_NO_COMMERCIAL_REASONS_FAILED:
      return {
        ...state,
        getNoCommercialReasonsIsLoading: false,
        getNoCommercialReasonsErrorMessage: 'SERVER ERROR'
      };

    case CommonConstants.GET_IMAGE_DATA_REQUEST:
      return {
        ...state,
        imageDataIsFetching: true,
        imageDataErrorMessage: ''
      };
    case CommonConstants.GET_IMAGE_DATA_SUCCESS:
      return {
        ...state,
        imageDataIsFetching: false,
        imageData: action.data
      };
    case CommonConstants.GET_IMAGE_DATA_FAILED:
      return {
        ...state,
        imageDataIsFetching: false,
        imageDataErrorMessage: 'SERVER ERROR'
      };
    case CommonConstants.GET_IMAGE_DATA_CLEAR:
      return {
        ...state,
        imageDataIsFetching: false,
        imageData: [],
        imageDataErrorMessage: ''
      };

    case CommonConstants.GET_IMAGES_TABLE_AGENCIES_REQUEST:
      return {
        ...state,
        getImagesTableAgenciesIsLoading: true,
        getImagesTableAgenciesErrorMessage: ''
      };
    case CommonConstants.GET_IMAGES_TABLE_AGENCIES_SUCCESS:
      return {
        ...state,
        getImagesTableAgenciesIsLoading: false,
        getImagesTableAgenciesData: action.data
      };
    case CommonConstants.GET_IMAGES_TABLE_AGENCIES_FAILED:
      return {
        ...state,
        getImagesTableAgenciesIsLoading: false,
        getImagesTableAgenciesErrorMessage: action.error.response.data
      };

    case CommonConstants.GET_LANGUAGES_REQUEST:
      return {
        ...state,
        languagesDataIsFetching: true,
        languagesDataErrorMessage: ''
      };
    case CommonConstants.GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        languagesDataIsFetching: false,
        languagesData: action.data
      };
    case CommonConstants.GET_LANGUAGES_FAILED:
      return {
        ...state,
        languagesDataIsFetching: false,
        languagesDataErrorMessage: 'SERVER ERROR'
      };
    case CommonConstants.GET_LANGUAGES_CLEAR:
      return {
        ...state,
        languagesDataIsFetching: false,
        languagesData: [],
        languagesDataErrorMessage: ''
      };

    case GET_FB_IMAGE_URL_REQUEST:
      return {
        ...state,
        facebookImageIsFetching: true,
        facebookImageUrlError: ''
      };
    case GET_FB_IMAGE_URL_SUCCESS:
      return {
        ...state,
        facebookImageIsFetching: false,
        facebookImageUrl: action.data
      };
    case GET_FB_IMAGE_URL_FAILED:
      return {
        ...state,
        facebookImageIsFetching: false,
        facebookImageUrlError: action.error
      };

    default:
      return state;
  }
};
